const CLIENT_ID_ONLINE = '684C957199C3BE6C153A778D1986032B';

export default CLIENT_ID_ONLINE;
